<template>
  <div>
    <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
      <b-form role="form" @submit.prevent="handleSubmit(submitGateway)">
        <card class="col-sm-12 col-lg-6">
          <h1>Gateway #{{ form.id }}</h1>
          <hr />
          <b-row>
            <b-col>
              <base-input
                v-model="form.major"
                label="Major"
                name="major"
                rules="numeric|required"
              ></base-input>
            </b-col>
            <b-col>
              <base-input
                v-model="form.minor"
                label="Minor"
                name="minor"
                rules="numeric|required"
              ></base-input>
            </b-col>
            <b-col>
              <base-input
                v-model="form.revision"
                label="Revision"
                name="revision"
                rules="numeric|required"
              ></base-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <base-textarea
                rows="4"
                v-model="form.description"
                label="Description"
                name="description"
                rules="required"
              ></base-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label class="form-control-label">Zip Image</label>
              <b-form-file
                accept=".zip"
                id="file"
                v-model="form.file1"
              ></b-form-file>
            </b-col>
          </b-row>

          <b-button type="submit" class="btn btn-block mt-3" variant="primary"
            >Submit</b-button
          >
        </card>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        file1: null,
        major: null,
        minor: null,
        revision: null,
        description: null,
      },
    };
  },
  async mounted() {
    let id = this.$route.query.id;
    if (id) {
      let r = await this.$client.get("/api/gateway/getGateway?id=" + id);
      this.form = r.data.value;
    }
  },
  methods: {
    async submitGateway() {
      if (this.form.id == null && !this.form.file1) {
        this.$emitter.emit("error", "You must select a file to upload");
        return;
      }

      let formData = new FormData();

      if (this.form.id != null) formData.append("id", this.form.id);

      formData.append("file", this.form.file1);
      formData.append("major", this.form.major);
      formData.append("minor", this.form.minor);
      formData.append("revision", this.form.revision);
      formData.append("description", this.form.description);

      let r = await this.$client.post("/api/gateway/upsertGateway", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      this.$emitter.emit("success", {
        title: "Gateway",
        message: this.form.id ? "Gateway Updated" : "Gateway added",
      });

      location.href = "/#/admin/gateways";
    },
  },
};
</script>

<style></style>
